import React from "react";

function Counseling() {
    return <div>Counseling</div>;
}

export default Counseling;
